import React from 'react';
import { Col, Row } from 'components/layout';
import {} from './ContentBlockFooter.types';
const ContentBlockFooter = ({ children, colProps, rowProps }) => (React.createElement(Col, { className: "content-block--footer", ...colProps },
    React.createElement(Row, { justifyContent: "center", ...rowProps }, children)));
export default ContentBlockFooter;
